module Meevo.Plugins.AlertsManager {

    import IAlertSetting = Meevo.Model.IAlertSetting;
    import ProactiveAlertTypeEnum = Meevo.Model.ProactiveAlertTypeEnum;

    interface IConfigurableView {
        componentName: string;
        data?: Object | ISingleMoverData | ISingleSpinnerData;
    }

    const CONFIGURABLE_VIEWS: { [key: number]: IConfigurableView } = {
        [ProactiveAlertTypeEnum.NoConfig]: {
            componentName: 'meevo-no-config-component'
        },
        [ProactiveAlertTypeEnum.SecurityOverrideOccured]: {
            componentName: 'meevo-security-override-occurs-config-component'
        },
        [ProactiveAlertTypeEnum.SecuredFeatureAccessed]: {
            componentName: 'meevo-security-override-occurs-config-component'
        },
        [ProactiveAlertTypeEnum.EmployeeClocksInEarlyOrLate]: {
            componentName: 'meevo-employee-locks-config-component',
            data: {
                label: 'EMPLOYEE_CLOCKED_IN_MORE_THAN'
            }
        },
        [ProactiveAlertTypeEnum.EmployeeClocksOutEarlyOrLate]: {
            componentName: 'meevo-employee-locks-config-component',
            data: {
                label: 'EMPLOYEE_CLOCKED_OUT_MORE_THAN'
            }
        },
        [ProactiveAlertTypeEnum.RefundWasGiven]: {
            componentName: 'meevo-refund-was-given-config-component',
            data: {
                choicesToShow: [
                    RefundTypes.All,
                    RefundTypes.Service,
                    RefundTypes.Product,
                    RefundTypes.GiftCard,
                    RefundTypes.Membership
                ]
            }
        },
        [ProactiveAlertTypeEnum.SpecificServiceIsRefunded]: {
            componentName: 'meevo-refund-was-given-config-component',
            data: { choicesToShow: [RefundTypes.Service] }
        },
        [ProactiveAlertTypeEnum.SpecificProductIsRefunded]: {
            componentName: 'meevo-refund-was-given-config-component',
            data: { choicesToShow: [RefundTypes.Product] }
        },
        [ProactiveAlertTypeEnum.SpecificPaymentTypeIsUsed]: {
            componentName: 'meevo-alert-manager-single-mover-config-component',
            data: <ISingleMoverData>{
                configKey: 'paymentTypes',
                name: 'paymentType',
                moverTemplate: 'PaymentType',
                labelAll: 'LABEL_ALL_PAYMENT_TYPES',
                useAllItemsAsSelected: true
            }
        },
        [ProactiveAlertTypeEnum.ClosingCashIsOverShortMoreThanAmount]: {
            componentName: 'meevo-closing-cash-component',
            data: {}
        },
        [ProactiveAlertTypeEnum.GiftCardIsRedeemedMoreThanMonthsOld]: {
            componentName: 'meevo-single-spinner-config-component',
            data: <ISingleSpinnerData>{
                firstLabel: 'LABEL_GIFT_CARD_REDEEMED_IS_OLDER_THAN',
                secondLabel: 'LABEL_MONTHS',
                min: 1,
                max: 1000,
                step: 1,
                configKey: 'olderThanMonths'
            }
        },
        [ProactiveAlertTypeEnum.SpecificMembershipIsSold]: {
            componentName: 'meevo-alert-manager-single-mover-config-component',
            data: <ISingleMoverData>{
                configKey: 'memberships',
                name: 'memberships',
                moverTemplate: 'Memberships',
                labelAll: 'LABEL_ALL_MEMBERSHIPS',
                useAllItemsAsSelected: true
            }
        },
        [ProactiveAlertTypeEnum.SpecificGiftCardTypeIsSold]: {
            componentName: 'meevo-alert-manager-single-mover-config-component',
            data: <ISingleMoverData>{
                configKey: 'giftCardTypes',
                name: 'giftCardType',
                moverTemplate: 'GiftCardType',
                labelAll: 'LABEL_ALL_GIFT_CARD_TYPE',
                useAllItemsAsSelected: true
            }
        },
        [ProactiveAlertTypeEnum.EmployeeWorksMore]: {
            componentName: 'meevo-employee-works-more-config-component'
        },
        [ProactiveAlertTypeEnum.AccessIsDeniedToACertainFeature]: {
            componentName: 'meevo-security-override-occurs-config-component'
        },
        [ProactiveAlertTypeEnum.QuickbooksHasNotBeenSyncedForAmountOfTime]: {
            componentName: 'meevo-alert-manager-amount-of-time-config-component'
        },
        [ProactiveAlertTypeEnum.EmployeeHasNotClockedIn]: {
            componentName: 'meevo-single-spinner-config-component',
            data: <ISingleSpinnerData>{
                firstLabel: 'LABEL_ALERT_ME_IF_EMPLOYEE_NOT_CLOCKED_AFTER',
                secondLabel: 'LABEL_MINUTES',
                default: 15,
                min: 15,
                max: 60,
                step: 15,
                configKey: 'alertAfterMinutes'
            }
        },
        [ProactiveAlertTypeEnum.AppointmentServiceAreCheckedIn]: {
            componentName: 'meevo-alert-manager-service-mover-config-component',
            data: <IServiceMoverData>{
                configKey: 'services',
                allConfigKey: 'allServices',
                servicesAllCheckboxHidden: false,
                showCategories: false
            }
        },
        [ProactiveAlertTypeEnum.AppointmentHasBeenCanceled]: {
            componentName: 'meevo-appointment-has-been-canceled-config-component',
            data: <ISingleMoverData>{
                configKey: 'appointmentHasBeenCanceledActionType',
            }
        },
        [ProactiveAlertTypeEnum.SpecificReportIsRun]: {
            componentName: 'meevo-alert-manager-report-is-run-config-component',
            data: <ISingleMoverData>{
                configKey: 'reports'
            }
        },
        [ProactiveAlertTypeEnum.SpecificServiceWasSold]: {
            componentName: 'meevo-alert-manager-service-mover-config-component',
            data: <IServiceMoverData>{
                configKey: 'services',
                allConfigKey: 'allServices'
            }
        },
        [ProactiveAlertTypeEnum.AllOrSpecificServiceBookedViaOnlineBooking]: {
            componentName: 'meevo-alert-manager-service-mover-config-component',
            data: <IServiceMoverData>{
                allConfigKey: 'allServices',
                showCategories: false,
                configKey: 'services'
            }
        },
        [ProactiveAlertTypeEnum.GifcardIsSoldOnline]: {
            componentName: 'meevo-gift-card-is-sold-config-component'
        },
        [ProactiveAlertTypeEnum.SmsHasReached]: {
            componentName: 'meevo-sms-has-reached-config-component',
            data: {
                configKey: 'usagePercentage'
            }
        },
        [ProactiveAlertTypeEnum.MarketingSmsHasReached]: {
            componentName: 'meevo-marketing-sms-has-reached-config-component',
            data: {
                configKey: 'marketingSmsUsagePercentage'
            }
        },
        [ProactiveAlertTypeEnum.MarketingEmailContactUsage]: {
            componentName: 'meevo-marketing-email-contact-has-reached-config-component',
            data: {
                configKey: 'marketingEmailContactUsagePercentage'
            }
        },
        [ProactiveAlertTypeEnum.SpecificPackageIsSold]: {
            componentName: 'meevo-alert-manager-single-mover-config-component',
            data: <ISingleMoverData>{
                configKey: 'packages',
                allConfigKey: 'allPackages',
                name: 'packages',
                moverTemplate: 'PackageType',
                useAllItemsAsSelected: false,
            }
        },
        [ProactiveAlertTypeEnum.ServiceIsBooked]: {
            componentName: 'meevo-employee-service-movers-config-component',
            data: <ISingleMoverData>{}
        },
        [ProactiveAlertTypeEnum.RatingIsSubmitted]: {
            componentName: 'meevo-alert-manager-rating-is-submitted-config-component',
            data: <ISingleMoverData>{}
        },
        [ProactiveAlertTypeEnum.ProductIsLowOnInventory]: {
            componentName: 'meevo-alert-smart-mover-config-component',
            data: <ISingleMoverData>{
                configKey: 'products',
                allConfigKey: 'allProducts',
                name: 'products',
                moverTemplate: 'productVariantsWithCategories',
                useAllItemsAsSelected: true,
            }
        },
        [ProactiveAlertTypeEnum.SpecificProductIsSold]: {
            componentName: 'meevo-alert-smart-mover-config-component',
            data: <ISingleMoverData>{
                configKey: 'productItemIds',
                allConfigKey: 'allProducts',
                name: 'products',
                moverTemplate: 'productWithCategoriesAndBundles',
                useAllItemsAsSelected: true,
                allSelected: false,
            }
        },
        [ProactiveAlertTypeEnum.DocsAndFormsHaveBeenSubmitted]: {
            componentName: 'meevo-alert-smart-mover-config-component',
            data: <ISingleMoverData>{
                configKey: 'selectedFormsIds',
                allConfigKey: 'allForms',
                name: 'forms',
                moverTemplate: 'docsAndFormsTemplate',
                useAllItemsAsSelected: true,
                allSelected: true,
            }
        },
        [ProactiveAlertTypeEnum.WaitListAppointmentIsAdded]: {
            componentName: 'meevo-wait-list-appointment-is-added-config-component',
            data: <ISingleMoverData>{
                configKey: 'waitlistActionType',
            }
        },
        [ProactiveAlertTypeEnum.InventoryProductLotApproachingExpiration]: {
            componentName: 'meevo-inventory-product-lot-approaching-expiration-config-component',
            data: {
                configKey: 'inventoryProductLotDaysBeforeExpiration'
            }
        },
    };


    class MeevoConfigureAlertTabComponent implements ng.IComponentController {

        static $inject = [
            '$scope',
            '$compile'
        ];

        public params: IParams;

        constructor(private $scope: ng.IScope,
                    private $compile: ng.ICompileService) {
        }

        $onInit() {
            this.$scope.$watch(() => this.params.alertSetting, (newValue: IAlertSetting, prevValue: IAlertSetting) => {
                if (newValue && newValue !== prevValue) {
                    const scope: any = this.$scope.$new(true, this.$scope);

                    let selectedView: IConfigurableView = CONFIGURABLE_VIEWS[newValue.alertType];

                    if (!selectedView) {
                        selectedView = CONFIGURABLE_VIEWS[ProactiveAlertTypeEnum.NoConfig];
                    }

                    scope.params = this.params;
                    scope.data = selectedView.data;

                    const html = `<${selectedView.componentName} params="params" data="data"></${selectedView.componentName}>`;
                    const element = $('#configurable-content');
                    element.children().remove();
                    element.append(this.$compile(html)(scope));
                }
            });
        }
    }

    angular.module('meevo.plugins.alertsManager')
        .component('meevoConfigureAlertTabComponent', <angular.IComponentOptions>{
            templateUrl: 'app/plugins/alertsManager/addNewAlert/tabs/configure-alert-tab/configure-alert-tab.component.html',
            controller: MeevoConfigureAlertTabComponent,
            controllerAs: '$ctrl',
            bindings: {
                params: '<'
            }
        });
}
